import Dashboard from './Dashboard.vue'

export default {
    path: '/',
    name: 'home',
    component: Dashboard
}
